module.exports = __webpack_public_path__ + "media/img/logo-4299264609932e364c53c6114762d7b9.svg";